"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeContext = void 0;
var _react = require("react");
var _theming = require("./theming.types");
var ThemeContext = exports.ThemeContext = /*#__PURE__*/(0, _react.createContext)({
  name: _theming.Theme.DEFAULT
});